import { jwtDecode } from "jwt-decode";
import { createSafeTimeoutHandle } from "app/utils/safeTimeout";

const localStorageService = (function () {
  let _service;
  const logoutTimer = createSafeTimeoutHandle();

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(tokenObj) {
    localStorage.setItem("accessToken", tokenObj.access_token);
    if (tokenObj.refreshToken) {
      localStorage.setItem("refreshToken", tokenObj.refreshToken);
    }

    _setLogoutTimer(tokenObj.access_token); // 🕒 Set timer when token is saved
  }

  function _getToken() {
    return localStorage.getItem("accessToken");
  }

  function _getRefreshToken() {
    return localStorage.getItem("refreshToken");
  }

  function _clearToken() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("appsCode");
    localStorage.clear();
    logoutTimer.clear();
  }

  function _setItem(key, value) {
    localStorage.setItem(key, value);
  }

  function _getItem(key) {
    return localStorage.getItem(key);
  }

  function _removeItem(key) {
    localStorage.removeItem(key);
  }

  // 🆕 Auto logout logic
  function _setLogoutTimer(accessToken) {
    try {
      const decoded = jwtDecode(accessToken);
      const exp = decoded.exp * 1000; // JWT exp is in seconds → convert to ms
      const currentTime = Date.now();
      const timeout = exp - currentTime;

      if (timeout > 0) {
        logoutTimer.schedule(() => {
          console.warn("Token expired — logging out.");
          _clearToken();
          window.location.href = "/session/signin";
        }, timeout);
      } else {
        // Token is already expired
        console.warn("Token already expired.");
        _clearToken();
        window.location.href = "/session/signin";
      }
    } catch (error) {
      console.error("Failed to decode token", error);
    }
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    removeItem: _removeItem,
    setItem: _setItem,
    getItem: _getItem,
    setLogoutTimer: _setLogoutTimer, // optional to call on app startup
  };
})();

export default localStorageService;
